import React, { useState } from 'react';
import '../css/ContactGridForm.css';

const ContactGridForm = () => {
  const [formData, setFormData] = useState({
    inquiryType: 'Enquiry',
    fullName: '',
    email: '',
    phone: '',
    course: '',
    message: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Inquiry Data Sent:', formData);
    alert('Thank you, Bhai! Your inquiry has been submitted successfully.');
  };

  return (
    <section className="gfi-ct-grid-section">
      <div className="gfi-ct-grid-container">
        <div className="gfi-ct-master-layout-mesh">
          
          {/* ==========================================================================
              LEFT MAIN COLUMN: BRANCHES AND LOCATIONS LIST MATRIX
             ========================================================================== */}
          <div className="gfi-ct-locations-stack">
            
            {/* ZONE 1: PRIMARY CORPORATE OFFICES */}
            <div className="gfi-ct-zone-header">
              <span className="gfi-ct-vertical-accent">|</span>
              <h3>Our Presence in Bihar</h3>
            </div>

            <div className="gfi-ct-cards-grid-row">
              
              <div className="gfi-ct-branch-card gfi-ct-card-featured-border">
                <div className="gfi-ct-card-head">
                  <span className="gfi-ct-icon-node">🏢</span>
                  <h4>Registered Office</h4>
                </div>
                <p className="gfi-ct-card-address">
                  Bajranj Nagar, Kashi Bazar<br />
                  Chapra, Bihar - 841301
                </p>
                <a href="#directions" className="gfi-ct-direction-link">📍 Get Directions</a>
              </div>

              <div className="gfi-ct-branch-card">
                <div className="gfi-ct-card-head">
                  <span className="gfi-ct-icon-node">📍</span>
                  <h4>Siwan Branch</h4>
                </div>
                <p className="gfi-ct-card-address">
                  2nd Floor, Tara Market, Ramrajya<br />
                  More, Station Road, Siwan (Bihar)<br />
                  <span className="gfi-ct-landmark">Near: Vishal Mega Mart</span>
                </p>
                <a href="#directions" className="gfi-ct-direction-link">📍 Get Directions</a>
              </div>

              <div className="gfi-ct-branch-card">
                <div className="gfi-ct-card-head">
                  <span className="gfi-ct-icon-node">📍</span>
                  <h4>Gopalganj Branch</h4>
                </div>
                <p className="gfi-ct-card-address">
                  DAV High School Campus,<br />
                  Station Road, Gopalganj (Bihar)
                </p>
                <a href="#directions" className="gfi-ct-direction-link">📍 Get Directions</a>
              </div>

            </div>

            {/* ZONE 2: FRANCHISEE NETWORK CHANNELS */}
            <div className="gfi-ct-zone-header gfi-ct-margin-top-md">
              <span className="gfi-ct-vertical-accent">|</span>
              <h3>Franchisee Centers</h3>
            </div>
            
            <p className="gfi-ct-disclaimer-text">
              *All courses available except NEBOSH courses at these centers.
            </p>

            <div className="gfi-ct-cards-grid-row">
              
              <div className="gfi-ct-branch-card gfi-ct-franchise-card">
                <h4>Maharajganj Branch</h4>
                <p className="gfi-ct-card-address">
                  J M Welfare Academy Campus, Near<br />
                  Railway Station, Maharajganj, Siwan
                </p>
              </div>

              <div className="gfi-ct-branch-card gfi-ct-franchise-card">
                <h4>Ara Branch</h4>
                <p className="gfi-ct-card-address">
                  Jain College, Station Road, Ara,<br />
                  Bhojpur
                </p>
                <a href="#directions" className="gfi-ct-direction-link">📍 Get Directions</a>
              </div>

              <div className="gfi-ct-branch-card gfi-ct-franchise-card">
                <h4>Mirganj Branch</h4>
                <p className="gfi-ct-card-address">
                  Near Railway Station, J P Chowk,<br />
                  Mirganj, Gopalganj
                </p>
              </div>

            </div>

            {/* ZONE 3: MASTER EXTERNAL NAVIGATION PANEL MAP TRACER */}
            <div className="gfi-ct-master-map-box">
              <h4>Get Directions</h4>
              <p>View all our centers and get real-time navigation through Google Maps.</p>
              <button className="gfi-ct-btn-gmaps">
                <span className="gfi-ct-btn-diamond">♦</span> OPEN IN GOOGLE MAPS
              </button>
            </div>

          </div>

          {/* ==========================================================================
              RIGHT MAIN COLUMN: FLOATING LEAD GENERATION ENGINE HUB
             ========================================================================== */}
          <div className="gfi-ct-form-desk-sidebar">
            <div className="gfi-ct-form-floating-card">
              
              <h3 className="gfi-ct-form-heading">Send Us a Message</h3>
              
              <form onSubmit={handleSubmit} className="gfi-ct-form-element-loop">
                
                <div className="gfi-ct-form-field">
                  <label>Inquiry Type</label>
                  <select name="inquiryType" value={formData.inquiryType} onChange={handleInputChange}>
                    <option value="Enquiry">Enquiry</option>
                    <option value="Admission">Admission</option>
                    <option value="Support">Support / Franchisee Inquiry</option>
                  </select>
                </div>

                <div className="gfi-ct-form-field">
                  <label>Full Name</label>
                  <input 
                    type="text" 
                    name="fullName" 
                    placeholder="Name" 
                    value={formData.fullName} 
                    onChange={handleInputChange} 
                    required 
                  />
                </div>

                <div className="gfi-ct-form-field">
                  <label>Email Address</label>
                  <input 
                    type="email" 
                    name="email" 
                    placeholder="Email address" 
                    value={formData.email} 
                    onChange={handleInputChange} 
                    required 
                  />
                </div>

                <div className="gfi-ct-form-field">
                  <label>Phone Number</label>
                  <input 
                    type="tel" 
                    name="phone" 
                    placeholder="Please enter your phone" 
                    value={formData.phone} 
                    onChange={handleInputChange} 
                    required 
                  />
                </div>

                <div className="gfi-ct-form-field">
                  <label>Select Course</label>
                  <select name="course" value={formData.course} onChange={handleInputChange} required>
                    <option value="">Select Course</option>
                    <option value="industrial-safety">Industrial Safety Management</option>
                    <option value="fire-safety">Fire & Safety Engineering</option>
                    <option value="nebosh">NEBOSH International Diploma</option>
                  </select>
                </div>

                <div className="gfi-ct-form-field">
                  <label>Requirements / Message</label>
                  <textarea 
                    name="message" 
                    rows="4" 
                    placeholder="Your message" 
                    value={formData.message} 
                    onChange={handleInputChange}
                  ></textarea>
                </div>

                {/* Simulated Security ReCAPTCHA Box matching image 18.JPG */}
                <div className="gfi-ct-recaptcha-mock">
                  <div className="gfi-ct-captcha-left">
                    <input type="checkbox" id="mock-captcha" required />
                    <label htmlFor="mock-captcha">I'm not a robot</label>
                  </div>
                  <div className="gfi-ct-captcha-right">
                    <div className="gfi-ct-captcha-logo">♻️</div>
                    <span>reCAPTCHA</span>
                  </div>
                </div>

                {/* Primary Action Button */}
                <button type="submit" className="gfi-ct-btn-submit-action">
                  SUBMIT INQUIRY
                </button>

              </form>

              {/* Direct Support Dynamic Telecom Grid footer matching image 18.JPG */}
              <div className="gfi-ct-form-footer-support-track">
                <span className="gfi-ct-support-lbl">Direct Support</span>
                <a href="tel:+918448445028" className="gfi-ct-tel-link">+91 8448445028</a>
                <a href="tel:+918102955178" className="gfi-ct-tel-link">+91 8102955178</a>
                <a href="tel:+919279224716" className="gfi-ct-tel-link">+91 9279224716</a>
                <span className="gfi-ct-support-email">info@growthacademy.in</span>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ContactGridForm;